import { ICamera } from '@api/models/camera.model';
import { Button, Drawer, Input } from '@hyperflake/react-ui-library';
import { Label } from '@library/forms';
import { CircularProgress } from '@library/loaders/components';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from 'httpConfig/http';
import { getResellerIdFromRedux } from 'modules/shared/helpers/shared.utils';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

interface ICameraRestoreConfirmationDrawer {
    open: boolean;
    onClose: () => void;
    camera: ICamera | null;
    onCameraUpdate?: (camera: ICamera) => void;
}

const CameraRestoreConfirmationDrawer = (props: ICameraRestoreConfirmationDrawer) => {
    const { onClose, camera, open, onCameraUpdate } = props;
    const [cameraName, setCameraName] = useState('');

    const { clientId, projectId } = useParams();
    // const queryClient = useQueryClient();

    const concludeCameraMutation = useMutation(async (payload: any) => {
        const { data, status } = await http.put(
            `${
                import.meta.env.VITE_APP_API_URL
            }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/cameras/${payload.id}/restore`
        );
        return { data, status };
    });
    const handleClose = () => {
        setCameraName('');
        onClose();
    };

    const handleRestore = async () => {
        if (camera === null) return onClose();
        try {
            const { data, status } = await concludeCameraMutation.mutateAsync({
                id: camera._id,
            });
            console.log({ data, status });
            toast.success(' TimeLapse Camera Is Restoring...');
            onCameraUpdate(data);
            // queryClient.setQueryData<ICamera[]>(['clients', clientId, 'projects', projectId, 'cameras'], (prev) => {
            //     if (!prev) return;

            //     const index = prev.findIndex((c) => c._id === camera._id);
            //     return produce(prev, (draft) => {
            //         draft.splice(index, 1);
            //         return draft;
            //     });
            // });
            handleClose();
        } catch (ex: any) {
            handleClose();
            console.log(ex.status);
            if (ex.status === 400) {
                toast.error(ex.data.message);
            } else {
                toast.error(ex?.data?.message || 'Some error occured, please try again.');
                console.log(ex);
            }
        }
    };

    return (
        <Drawer open={open} onClose={handleClose} title="Confirm Restore">
            <div>
                <div>
                    <Label className="mt-2 inline-block">
                        To confirm restore write:<span className="font-semibold">RESTORE</span>
                    </Label>
                    <Input
                        placeholder="Enter RESTORE"
                        // className="w-96 bg-white"
                        onChange={(e) => setCameraName(e.target.value)}
                        value={cameraName}
                    />

                    <div className="flex gap-2 mt-2">
                        <Button
                            disabled={concludeCameraMutation.isLoading}
                            onClick={() => onClose()}
                            variant="default"
                            color={'primary'}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={cameraName !== 'RESTORE'}
                            className="w-20"
                            onClick={() => handleRestore()}
                            variant="default"
                            color={'primary'}
                        >
                            {concludeCameraMutation.isLoading ? (
                                <CircularProgress size={18} color={'inherit'} />
                            ) : (
                                'Restore'
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default CameraRestoreConfirmationDrawer;
